<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" routerLink="/master-data">Master Data</a><span>/ Repair Mode</span>
</div>

<form [formGroup]="filterFormGroup" class="list-repair-mode-container">
  <div class="pure-g">
    <div class="pure-u-md-10-24 pure-u-lg-14-24">
      <h3 class="inline m-r-4" i18n>Repair Mode</h3>
    </div>
    <div class="pure-u-md-14-24 pure-u-lg-10-24 right">
      <app-repair-mode-search
        class="search-bar"
        [repairModeSearchTextForm]="filterFormGroup.controls.repairModeSearchTextForm">
      </app-repair-mode-search>
    </div>
  </div>
  <app-repair-mode-filters [filterFormGroup]="filterFormGroup"></app-repair-mode-filters>
  <app-repair-mode-grid [filterFormGroup]="filterFormGroup" class="table-container"></app-repair-mode-grid>
</form>
